import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import SelectField from 'Components/ComponentLibrary/Components/Uncategorized/SelectField';
import HorizontalPicklist from 'Components/ComponentLibrary/Molecules/HorizontalPicklist';

export const SelectAssetLiabilityTypeOverride = buildFacetDesignOverride()
  .nameOverride('assetLiabilityType', { _component: () => HorizontalPicklist }, overrideReadOnly);

export const SelectAssetLiabilityTypeDOOverride = buildFacetDesignOverride()
  .typeOverride('picklist', {
    _component: () => SelectField,
    _customProps: {
      helperText: '',
    },
  }, overrideReadOnly)
  .nameOverride('assetLiabilityType', { _component: () => HorizontalPicklist }, overrideReadOnly);
